export default __webpack_public_path__ + "static/media/earth_icon.93d0d829.svg";